import { render, staticRenderFns } from "./MfStonks.vue?vue&type=template&id=9bc4bfd8&scoped=true"
import script from "./MfStonks.vue?vue&type=script&lang=js"
export * from "./MfStonks.vue?vue&type=script&lang=js"
import style0 from "./MfStonks.vue?vue&type=style&index=0&id=9bc4bfd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bc4bfd8",
  null
  
)

export default component.exports